import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SceneToken } from "../enums/scene-token.enum";
import { Scene } from "../interfaces/scene.interface";

export const useProgress = (scene: Scene | undefined, total: number) => {
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();
  const currentIndex = (scene?.subState?.data?.index | 0);
  const currentQuestion = currentIndex + 1;
  const questionValue = Math.round(100 / total * currentQuestion);
  const ratio = currentIndex ? Math.max((total - currentIndex)/(total/2.7), 1) : 1;

  useEffect(() => {
    switch (scene?.token) {
      case SceneToken.START_PAGE: setValue(0); break;
      case SceneToken.QUESTION: {
        setValue(oldValue => Math.max(questionValue*ratio, oldValue));
        break;
      }
      case SceneToken.FORM: setValue(99); break;
      case SceneToken.RESULT: case SceneToken.FINAL: setValue(100); break;
      default: break;
    }
  }, [scene, total, dispatch, questionValue, ratio]);

  return value;
}